import { render } from "./VideoManager.vue?vue&type=template&id=27b730a7&scoped=true"
import script from "./VideoManager.vue?vue&type=script&lang=js"
export * from "./VideoManager.vue?vue&type=script&lang=js"

import "./VideoManager.vue?vue&type=style&index=0&id=27b730a7&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27b730a7"]])

export default __exports__